import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { CheckboxStyle } from './CheckboxStyle'

export default class Checkbox extends PureComponent {
    static propTypes = {
      checked: PropTypes.bool,
      label: PropTypes.string,
      disabled: PropTypes.bool,
      onChange: PropTypes.func,
      value: PropTypes.string
    }
    static defaultProps = {
      disabled: false
    }

    state = {
      checked: this.props.checked
    }

    onChange (e) {
      const { onChange } = this.props
      const { checked } = e.target
      this.setState({
        checked: checked
      })
      onChange(!!e.target.checked)
    }

    UNSAFE_componentWillReceiveProps (newProps) {
      if (newProps && typeof newProps.checked !== 'undefined') {
        this.setState({ checked: newProps.checked })
      }
    }

    render () {
      const { disabled, editable, className } = this.props
      const { checked } = this.state
      return (
        <div className={`custom-control custom-checkbox ${className || ``}`}>
          <input
            type={`checkbox`}
            className={`custom-control-input`}
            disabled={editable === false || disabled}
            checked={checked}
            onChange={this.onChange.bind(this)}
          />
          <label className={`custom-control-label`} />
          <style jsx>{CheckboxStyle}</style>
        </div>
      )
    }
}
